import { PROFILE_SETTINGS_FORM_FIELDS, PROFILE_SETTINGS_FORM_FIELDS_NAMES } from './profile-settings-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const PERSONAL_INFORMATION_INPUTS = (): IFormInputProps[] => [
	{
		key: PROFILE_SETTINGS_FORM_FIELDS.FIRST_NAME,
		fieldName: PROFILE_SETTINGS_FORM_FIELDS.FIRST_NAME,
		label: PROFILE_SETTINGS_FORM_FIELDS_NAMES.FIRST_NAME,
		placeholder: PROFILE_SETTINGS_FORM_FIELDS_NAMES.FIRST_NAME,
		inputType: InputType.Text,
		autoComplete: 'off'
	},
	{
		key: PROFILE_SETTINGS_FORM_FIELDS.LAST_NAME,
		fieldName: PROFILE_SETTINGS_FORM_FIELDS.LAST_NAME,
		label: PROFILE_SETTINGS_FORM_FIELDS_NAMES.LAST_NAME,
		placeholder: PROFILE_SETTINGS_FORM_FIELDS_NAMES.LAST_NAME,
		inputType: InputType.Text,
		autoComplete: 'off'
	},
	{
		key: PROFILE_SETTINGS_FORM_FIELDS.EMAIL,
		fieldName: PROFILE_SETTINGS_FORM_FIELDS.EMAIL,
		label: PROFILE_SETTINGS_FORM_FIELDS_NAMES.EMAIL,
		placeholder: PROFILE_SETTINGS_FORM_FIELDS_NAMES.EMAIL,
		additionalClasses: 'disabled',
		inputType: InputType.Text,
		autoComplete: 'off'
	},
	{
		key: PROFILE_SETTINGS_FORM_FIELDS.PHONE,
		fieldName: PROFILE_SETTINGS_FORM_FIELDS.PHONE,
		label: PROFILE_SETTINGS_FORM_FIELDS_NAMES.PHONE,
		inputType: InputType.Phone,
		defaultCountry: 'US',
		additionalClasses: 'number-input-zip',
		autoComplete: 'off'
	}
];
